module.exports = __webpack_public_path__ + "img/big-ship-wreck-3.6a53d783.png";